import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import './styles/partners-list.scss';

import AirbnbLogo from '@images/aribnb-logo.webp';
import IntelLogo from '@images/intel-logo.webp';
import LinkedInLogo from '@images/linkedin-logo.png';
import PwcLogo from '@images/pwc-logo.webp';
import StravaLogo from '@images/strava-logo.jpg';
import VistaPrintLogo from '@images/vistaprint-logo.webp';
import SamsungLogo from '@images/samsung-logo.png';
import CocaColaLogo from '@images/coca_cola_logo.png';
import AAALogo from '@images/aaa_logo.png';
import BBBLogo from '@images/bbb_logo.png';
import UbiquitiLogo from '@images/ubiquiti-logo.png';
import ArloLogo from '@images/arlo_logo.png';

import TataNexarcLogo from '@images/indian-partners-list/tata-nexarc-logo.png';
import UnileverLogo from '@images/indian-partners-list/unilever-logo.png';

import { t } from '@i18n/i18n';
import partnersListTranslations from '@i18n/translations/components/partners-list/partners-list.json';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import Carousel from '../carousel/carousel';

const PartnersList = ({ title, additionalClass }) => {
  useI18nInitNamespace('partnersList', partnersListTranslations, true);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div className={cx('partners-list', additionalClass)}>
      <div className="shell partners-list-shell">
        {title && (
          <h2
            id="partners_list_header"
            className="h3"
            {...(isClient
              ? {
                  'data-aos': 'fade',
                  'data-aos-delay': '50',
                }
              : {})}
          >
            {isClient ? title : t('The_1')}
          </h2>
        )}

        {isClient ? (
          <Carousel speed="5000" slidesToShow={1} autoplay loop fade>
            <div className="partners-list__slide">
              <ul className="partners-list__images">
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="50">
                  <div
                    id="partners_logo_1"
                    className="bg-amazon_logo"
                    role="img"
                    aria-label="Amazon Logo Partner"
                    alt={t('Amazon_logo', true)}
                  />
                </li>

                <li data-aos="fade" data-aos-offset="10" data-aos-delay="100">
                  <CloudflareImage
                    id="partners_logo_2"
                    src={SamsungLogo}
                    alt={t('Samsung_logo', true)}
                    width="110"
                    height="37"
                    loading="lazy"
                    decoding="async"
                  />
                </li>

                <li data-aos="fade" data-aos-offset="10" data-aos-delay="150">
                  <div
                    id="partners_logo_3"
                    className="bg-netflix_logo"
                    role="img"
                    aria-label="Netflix Logo Partner"
                    alt={t('Netflix_logo', true)}
                  />
                </li>

                <li data-aos="fade" data-aos-offset="10" data-aos-delay="200">
                  <div
                    id="partners_logo_4"
                    className="bg-disney_logo"
                    role="img"
                    aria-label="Disney Logo Partner"
                    alt={t('Disney_logo', true)}
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="100">
                  <CloudflareImage
                    id="partners_logo_2"
                    src={CocaColaLogo}
                    alt={t('CocaCola_logo', true)}
                    width="120"
                    height="37"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              </ul>
            </div>

            <div className="partners-list__slide">
              <ul className="partners-list__images">
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="250">
                  <div
                    id="partners_logo_5"
                    className="bg-sephora_logo"
                    role="img"
                    aria-label="Sephora Logo Partner"
                    alt={t('Sephora_logo', true)}
                  />
                </li>

                <li data-aos="fade" data-aos-offset="10" data-aos-delay="600">
                  <CloudflareImage
                    id="partners_img_12"
                    src={AAALogo}
                    alt={t('AAA_logo', true)}
                    width="123"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="650">
                  <CloudflareImage
                    id="partners_img_13"
                    src={BBBLogo}
                    alt={t('BBB_logo', true)}
                    width="80"
                    height="40"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="700">
                  <CloudflareImage
                    id="partners_img_14"
                    src={UbiquitiLogo}
                    alt={t('Ubiquiti_logo', true)}
                    width="100"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              </ul>
            </div>

            <div className="partners-list__slide">
              <ul className="partners-list__images">
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="700">
                  <CloudflareImage
                    id="partners_img_14"
                    src={ArloLogo}
                    alt={t('Arlo_logo', true)}
                    width="80"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="300">
                  <div
                    id="partners_logo_6"
                    className="bg-hubspot_logo"
                    role="img"
                    aria-label="Hubspot Logo Partner"
                    alt={t('Hubspot_logo', true)}
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="350">
                  <CloudflareImage
                    id="partners_img_7"
                    src={IntelLogo}
                    alt={t('Intel_logo', true)}
                    width="75"
                    height="50"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="400">
                  <CloudflareImage
                    id="partners_img_8"
                    src={AirbnbLogo}
                    alt={t('Airbnb_logo', true)}
                    width="120"
                    height="38"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="450">
                  <CloudflareImage
                    id="partners_img_9"
                    src={LinkedInLogo}
                    alt={t('LinkedIn_logo', true)}
                    width="115"
                    height="32"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              </ul>
            </div>

            <div className="partners-list__slide">
              <ul className="partners-list__images">
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="500">
                  <CloudflareImage
                    id="partners_img_10"
                    src={PwcLogo}
                    alt={t('Pwc_logo', true)}
                    width="120"
                    height="91"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="550">
                  <CloudflareImage
                    id="partners_img_11"
                    src={VistaPrintLogo}
                    alt={t('VistaPrint_logo', true)}
                    width="120"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>

                <li data-aos="fade" data-aos-offset="10" data-aos-delay="600">
                  <CloudflareImage
                    id="partners_img_12"
                    src={StravaLogo}
                    alt={t('Strava_logo', true)}
                    width="123"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="650">
                  <CloudflareImage
                    id="partners_img_13"
                    src={TataNexarcLogo}
                    alt={t('TataNexarc_logo', true)}
                    width="120"
                    height="38"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li data-aos="fade" data-aos-offset="10" data-aos-delay="700">
                  <CloudflareImage
                    id="partners_img_14"
                    src={UnileverLogo}
                    alt={t('Unilever_logo', true)}
                    width="70"
                    height="25"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              </ul>
            </div>
          </Carousel>
        ) : (
          <noscript>
            <div className="partners-list__slide">
              <ul className="partners-list__images">
                <li>
                  <div
                    id="partners_logo_1"
                    className="bg-amazon_logo"
                    role="img"
                    aria-label="Amazon Logo Partner"
                    alt={t('Amazon_logo', true)}
                  />
                </li>
                <li>
                  <img id="partners_logo_2" src={SamsungLogo} alt={t('Samsung_logo', true)} width="110" height="37" />
                </li>
                <li>
                  <div
                    id="partners_logo_3"
                    className="bg-netflix_logo"
                    role="img"
                    aria-label="Netflix Logo Partner"
                    alt={t('Netflix_logo', true)}
                  />
                </li>
                <li>
                  <div
                    id="partners_logo_4"
                    className="bg-disney_logo"
                    role="img"
                    aria-label="Disney Logo Partner"
                    alt={t('Disney_logo', true)}
                  />
                </li>
                <li>
                  <img id="partners_logo_5" src={CocaColaLogo} alt={t('CocaCola_logo', true)} width="120" height="37" />
                </li>
              </ul>
            </div>
          </noscript>
        )}
      </div>
    </div>
  );
};

export default PartnersList;
